import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import Form from "../../../../../forms/others/form/index.js";
import { SearcherActivitiesProvider } from "../../context/index.js";
import useSearcherActivitiesForm from "../../hooks/useSearcherActivitiesForm.js";
const SearcherActivitiesRedirectingModal = /*#__PURE__*/ lazy(()=>import("../redirecting-modal/index.js"));
const SearcherActivitiesForm = ({ children , ...rootProps })=>{
    const props = 'data' in rootProps ? rootProps.data : rootProps.props;
    const { onSubmit , isRedirecting , defaultValues  } = useSearcherActivitiesForm(props);
    return /*#__PURE__*/ _jsx(Form, {
        onSubmit: onSubmit,
        defaultValues: defaultValues,
        children: /*#__PURE__*/ _jsxs(SearcherActivitiesProvider, {
            value: props,
            children: [
                children,
                /*#__PURE__*/ _jsx(Suspense, {
                    fallback: null,
                    children: isRedirecting && /*#__PURE__*/ _jsx(SearcherActivitiesRedirectingModal, {})
                })
            ]
        })
    });
};
export default SearcherActivitiesForm;

//# sourceMappingURL=index.js.map